import { ActionFunctionArgs, LoaderFunction, redirect } from 'react-router-dom'

import type { Category } from '@/apiTypes.ts'
import { selectAppointmentTypePath } from '@/router/paths.ts'
import { fetchFromApi } from '@/utils/fetchFromApi.ts'
import { sortVelthuisCategories } from '@/utils/sortVelthuisCategories.ts'

interface LoaderData {
  categories?: Category[]
  loadTime?: number
  error?: string
}

interface ActionData {
  error?: string
}

const action = async ({
  request,
}: ActionFunctionArgs): Promise<ActionData | Response> => {
  const formData = await request.formData()
  const category = formData.get('category') as string

  return redirect(selectAppointmentTypePath({ category }))
}

const loader: LoaderFunction<LoaderData> = async (): Promise<
  LoaderData | Response | null
> => {
  const startTime = Date.now()
  try {
    const response = await fetchFromApi(`categories`)

    if (!response.ok) {
      throw new Error('Failed to fetch categories')
    }
    const categories: Category[] = await response.json()

    return {
      categories: sortVelthuisCategories(categories),
      loadTime: Date.now() - startTime,
    }
  } catch (error) {
    console.error('Error fetching appointment slots:', error)
    return {
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    }
  }
}

export type { ActionData, LoaderData }
export { action, loader }
